<script lang="ts">
  // lib imports
  import i18n from "@/stores/i18n";
  import { localizeUrl, type SupportedLanguage } from "@/helpers/localization";
  import Cookies from "universal-cookie";
  // ui imports
  import Image from "@/components/ui/image/image.svelte";
  import * as Select from "@/components/ui/select";
  // assets imports
  import en from "@/images/countries/US.svg";
  import fr from "@/images/countries/FR.svg";
  import de from "@/images/countries/DE.svg";
  import nl from "@/images/countries/NL.svg";
  import es from "@/images/countries/ES.svg";

  const languagesOptions: { value: SupportedLanguage; icon: any }[] = [
    {
      value: "en",
      icon: en
    },
    {
      value: "fr",
      icon: fr
    },
    {
      value: "de",
      icon: de
    },
    {
      value: "nl",
      icon: nl
    },
    {
      value: "es",
      icon: es
    }
  ];

  let value = $state<string[]>();

  const handleLanaugageSelect = (option: string) => {
    // set i18next cookie
    const cookies = new Cookies();
    cookies.set("i18next", option, { path: "/" });
    // reload page & add new locale to path
    window.location.href = localizeUrl(window.location.href, option);
  };

  let icon =
    languagesOptions.find((option) => option.value === $i18n.language)?.icon ||
    en;
</script>

<Select.Root type="single" onValueChange={handleLanaugageSelect}>
  <Select.Trigger
    class="h-[42px] w-[90px] rounded-[8px] border border-dark-gray bg-light-black text-sm font-semibold leading-6 text-light-gray placeholder:text-medium-gray focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0">
    <div class="flex w-full items-center justify-center gap-2">
      <Image
        src={icon}
        alt={`${$i18n.language} flag`}
        class="h-4 w-4 object-contain" />
      <span class="uppercase">{$i18n.language}</span>
    </div>
  </Select.Trigger>
  <Select.Content class="min-w-[90px]">
    {#each languagesOptions as option}
      <Select.Item
        value={option.value}
        class="flex w-full items-center justify-center">
        <div class="flex w-full items-center justify-center gap-2">
          <Image
            src={option.icon}
            alt={`${option.value} flag`}
            class="h-4 w-4 object-contain" />
          <span class="uppercase">{option.value}</span>
        </div>
      </Select.Item>
    {/each}
  </Select.Content>
</Select.Root>
